import { render } from "./AccountSettingsView.vue?vue&type=template&id=2ef2c2fe&scoped=true"
import script from "./AccountSettingsView.vue?vue&type=script&lang=js"
export * from "./AccountSettingsView.vue?vue&type=script&lang=js"

import "./AccountSettingsView.vue?vue&type=style&index=0&id=2ef2c2fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef2c2fe"]])

export default __exports__